import React from 'react';
import HeadTittle from '../../../../../../components/HeadTittle';
import DivContainerBody from '../../../../../../components/DivContainerBody';
import CustomCard from '../../../../../../components/CustomCard';
import CustomTabContainer from '../../../../../../components/CustomTabContainer';
import CustomTab from '../../../../../../components/CustomTab';
import ActivePeriodTab from './SubComponents/ActivePeriodTab';
import PayrollUserDetailsCard from './SubComponents/PayrollUserDetailsCard';
import PayrollUserDetailsApp from './Functionality/PayrollUserDetailsApp';
import { PAYROLL_DETAIL_TABS, PAYROLL_USER_DETAILS_TABS } from './Model/Model';
import PayrollUserHistoryTable from "./SubComponents/PayrollUserHistoryTable";
import {ATTENDANCE_SUBVIEW_MODEL} from "../../Model/Model";
import {permissionObj} from "../../../../../../Helpers/permission";
import routes from "../../../../../../Routes/routes";
import ExportDataBtn from "../../../../../../components/buttons/ExportDataBtn";
/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const PayrollUserDetails = () => {
    const {
        t,
        navigate,
        DEV,
        permission,
        goBack,
        activeTab,
        setActiveTab,
        userDetail,
        userId,
        payrollResultId,
        currentSubView,
        canExport,
        exportModuleId,
        exportOption,
        bodyForExport
    } = PayrollUserDetailsApp();


    if (!DEV &&
        !permission?.includes(permissionObj?.WEB_PAYROLL_ACTIVE_READ) &&
        !permission?.includes(permissionObj?.WEB_PAYROLL_HISTORY_READ)
    ) {
        navigate(routes.forbidden);
    }


    return (
        <>
            <HeadTittle
                name='details'
                onBack={goBack}
            >
                {canExport && (
                    <ExportDataBtn
                        id='btn_pud_export'
                        moduleId={exportModuleId}
                        option={exportOption}
                        body={bodyForExport}
                        search={false}
                        contractorSupplier={false}
                    />
                )}
            </HeadTittle>
            <DivContainerBody>
                <div className='row px-0 h-100'>
                    <div className='col-sm-12 col-md-4 col-lg-4 mb-lg-0 mb-md-3 mb-sm-3 px-1'>
                        <PayrollUserDetailsCard userDetail={userDetail} />
                    </div>
                    <div className='col-sm-12 col-md-8 col-lg-8 px-1'>
                        <CustomCard classes='h-100' classCard='card-border-8px' classContent='p-0'>
                            { currentSubView ===  ATTENDANCE_SUBVIEW_MODEL.PAYROLL.ACTIVE &&
                                <>
                                    <div className='px-2'>
                                        <CustomTabContainer
                                            activeTab={activeTab}
                                            setActiveTab={setActiveTab}
                                            className='rounded-top border-0'
                                        >
                                            {PAYROLL_USER_DETAILS_TABS.map((tab) => (
                                                <CustomTab
                                                    key={tab.key}
                                                    id={tab.key}
                                                    title={t(tab.trans)}
                                                    isSelected={activeTab === tab.key}
                                                    label={t(tab.trans)}
                                                    selected={activeTab === tab.key}
                                                    onClick={() => setActiveTab(tab.key)}
                                                />
                                            ))}
                                        </CustomTabContainer>
                                    </div>
                                    <div className='border-bottom-shades-300' />
                                </>
                            }

                            {activeTab === PAYROLL_DETAIL_TABS.ACTIVE_PERIOD && (
                                <ActivePeriodTab id={payrollResultId} />
                            )}
                            {activeTab === PAYROLL_DETAIL_TABS.HISTORY && (
                                <PayrollUserHistoryTable id={userId} />
                            )}
                        </CustomCard>
                    </div>
                </div>
            </DivContainerBody>
        </>
    );
};

export default PayrollUserDetails;
